export default __webpack_public_path__ + "static/media/utp19.b3354152.jpg";